import { cn } from "@synthesis/shared-utils";

import { CREATE_APPLICATION_STEPS, getCreateApplicationStepIndex, usePageStore, type CreateApplicationStepKey } from "../create-application-page.lib";
import { observer } from "mobx-react-lite";

type CreateApplicationStepperProps = {
  className?: string;
};

const getStepState = (stepKey: CreateApplicationStepKey, activeStep: CreateApplicationStepKey) => {
  const stepIndex = getCreateApplicationStepIndex(stepKey);
  const activeIndex = getCreateApplicationStepIndex(activeStep);

  if (stepIndex < activeIndex) {
    return "completed";
  }

  if (stepIndex === activeIndex) {
    return "active";
  }

  return "upcoming";
};

export const CreateApplicationStepper = observer(({ className }: CreateApplicationStepperProps) => {
  const pageStore = usePageStore();
  const activeStep = pageStore?.activeStep ?? "type";

  return (
    <div className={cn("grid grid-cols-4 gap-2", className)} aria-label="Шаги создания заявки">
      {CREATE_APPLICATION_STEPS.map((step) => {
        const state = getStepState(step.key, activeStep);

        return (
          <div key={step.key} className="flex min-w-0 flex-col items-center gap-1">
            <span
              className={cn(
                "paragraph-sm w-full truncate text-center",
                state === "active" && "text-type-common",
                state === "completed" && "text-system-success-50",
                state === "upcoming" && "text-type-light",
              )}
            >
              {step.label}
            </span>
            <div
              className={cn(
                "h-1 w-full rounded-sm",
                state === "active" && "bg-neutrals-60",
                state === "completed" && "bg-system-success-50",
                state === "upcoming" && "bg-neutrals-90",
              )}
              aria-hidden
            />
          </div>
        );
      })}
    </div>
  );
});
